export default {
  documents(state) {
    return state.documents
  },
  summary(state) {
    return state.summary
  },
  fullSummary(state) {
    return state.fullSummary
  },
  pagination(state) {
    return state.pagination
  },
  hasDocuments(state) {
    return state.hasDocuments
  },
  arDocuments(state) {
    return state.documents.filter((d) => d.direction === 'AR')
  },
  apDocuments(state) {
    return state.documents.filter((d) => d.direction === 'AP')
  },
}

